import { createReducer } from '/@/store/utils';
import * as actions from './actions';

const initial = {
    historicalConsultations: [],
    batchData: undefined,
};

export default createReducer(initial, {
    [actions.setHistoricalConsultations]: (state, action) => {
        return { ...state, historicalConsultations: action.payload };
    },
    [actions.setBatchData]: (state, action) => {
        return { ...state, batchData: action.payload };
    },
    [actions.resetBatchData]: (state) => {
        return { ...state, batchData: undefined };
    },
});
